module.exports = __webpack_public_path__ + "static/img/calioh.8751d1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/calioh.png
// module id = 2WI4
// module chunks = 0